var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LoginForm',{attrs:{"init-is-processing":_vm.isProcessing,"need-clear-password":_vm.needClearPassword},on:{"after-form-submit":_vm.afterFormSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }